module.exports = __webpack_public_path__ + "img/9788954436120.96f0071b.jpg";